import * as Yup from "yup";
import { signatureValidationSchema } from "../../modules/Signature/editRequirementDefinition/signatureValidationSchema";
import { backgroundChecksValidationSchema } from "../../modules/BackgroundChecks/editRequirementDefinition/backgroundChecksValidationSchema";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { identityVerificationValidationSchema } from "../../modules/IdentityVerification/editRequirementDefinition/identityVerificationValidationSchema";
import { sharedFileValidationSchema } from "../../modules/SharedFile/editRequirementDefinition/sharedFileValidationSchema";
import { insuranceCoverageValidationSchema } from "../../modules/InsuranceCoverage/createRequirementDefinition/insuranceCoverageValidationSchema";

const baseValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string()
});

const validations: Record<RequirementType, Yup.ObjectSchema<any>> = {
  [RequirementType.Signature]: signatureValidationSchema,
  [RequirementType.SharedFile]: sharedFileValidationSchema,
  [RequirementType.BackgroundCheck]: backgroundChecksValidationSchema,
  [RequirementType.IdentityVerification]: identityVerificationValidationSchema,
  [RequirementType.InsuranceCoverage]: insuranceCoverageValidationSchema
};

export const getEditRequirementDefinitionValidationSchema = (
  requirementType: RequirementType
) => baseValidationSchema.concat(validations[requirementType]);
